import useUserPermissions from "../../../../../common/utils/user/permissions/use-user-permissions";
import routeActiveListingUserPermissionDefinition from "./route-active-listing-user-permission";

const useRouteActiveListingUserPermissions = () => {
  return useUserPermissions(routeActiveListingUserPermissionDefinition);
};

export default useRouteActiveListingUserPermissions;
